import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";
import { COMPARISON } from "@/data/site";
import { EASE, SectionHead } from "@/components/motion/Reveal";
import { LogoMark } from "@/components/brand/Logo";

export const WhyBrewer = ({ index = "07" }) => (
  <section className="relative overflow-hidden py-28 lg:py-40" data-testid="why-brewer-section">
    <div className="pointer-events-none absolute right-[-10%] top-1/3 h-[50vh] w-[50vh] rounded-full bg-volt/10 blur-[140px]" />
    <div className="container-x relative">
      <SectionHead index={index} eyebrow="Why Brewer" title={["The partner difference", "your customers feel."]}>
        Plenty of companies can sell you a machine. Brewer stays with you after it's plugged in.
      </SectionHead>
      <div className="mt-16 overflow-hidden rounded-[28px] border border-white/5">
        <div className="grid grid-cols-2 border-b border-white/5 bg-ink-800 md:grid-cols-12">
          <div className="hidden p-6 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 md:col-span-4 md:block">What you get</div>
          <div className="flex items-center gap-3 border-r border-white/5 bg-volt/[0.06] p-6 md:col-span-4 md:border-l">
            <LogoMark className="h-8 w-8" />
            <span className="font-display text-base font-bold text-white sm:text-lg">Brewer Amusement</span>
          </div>
          <div className="p-6 font-display text-base font-semibold text-slate-500 md:col-span-4 sm:text-lg">Typical supplier</div>
        </div>
        {COMPARISON.map(([ours, theirs], i) => (
          <motion.div
            key={ours}
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.06 }}
            className="grid grid-cols-2 border-b border-white/5 last:border-0 md:grid-cols-12"
            data-testid={`comparison-row-${i + 1}`}
          >
            <div className="hidden p-6 font-mono text-xs text-slate-600 md:col-span-4 md:block">0{i + 1}</div>
            <div className="flex items-start gap-3 border-r border-white/5 bg-volt/[0.04] p-5 text-sm text-white sm:p-6 sm:text-base md:col-span-4 md:border-l">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-volt" /> {ours}
            </div>
            <div className="flex items-start gap-3 p-5 text-sm text-slate-500 sm:p-6 sm:text-base md:col-span-4">
              <Minus className="mt-0.5 h-4 w-4 shrink-0 text-signal/70" /> {theirs}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
